module.exports = __webpack_public_path__ + "media/images/icon-exit-green-2042eeb611e1b1965e2fdfb128bf4ff2.svg";